import styled from 'styled-components';
import breakpoint from 'components/utils/responsive';
import { colorToken } from "components/utils/constants";

export default styled.div`
    min-height: 100vh;
    display: flex;
    padding-top: 95px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-image: url('/assets/img/bg-home.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    
    img {
        max-width: 100%;
    }
    @media ${breakpoint.md} {
        padding-top: 100px;
        /* flex-basis: 50%;
        flex-direction: row; */
    }
`;

export const StyleContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    transition: max-height linear 0.2s;
    align-items: center;
    width: 100%;
    flex-grow: 1;
    min-height: 500px;
    
    justify-content: space-between;
    img{
        max-width: 20%;
        width: 100%;
        min-width: 200px;
        margin-bottom: 32px;
    }
    > div {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    p{
        color: ${colorToken.white};
        text-align: center;
        padding: 0 16px;
    }
    @media ${breakpoint.md} {
        /* flex-basis: 50%;
        flex-direction: row; */
        p{
            width: 65%;
        }
    }

`;

export const StyleButtonContainer = styled.div`
    margin-bottom: 8px;
    padding: 0 16px;
    p{
        width: 100%;
        font-size: 1.2rem;
    }
`;

export const StyleContentWrapperNumeros = styled.div`
    display: flex;
    flex-direction: column;
    padding: 12px;
    max-width: 1268px;
    max-height: ${({ openedStep }) => (openedStep ? "auto" : "0")};
    padding: ${({ openedStep }) => (openedStep ? "24px 12px" : "0")};
    width: ${({ openedStep }) => (openedStep ? "100%" : "0")};
    overflow-y: hidden;
    transition: max-height linear 0.2s;
    @media ${breakpoint.md} {
    }

`;


export const StyleImg = styled.img`
    max-width: 100%;
    border-radius: 12px 12px 0 0;
    @media ${breakpoint.md} {
        border-radius: 24px 0 0 24px;
    }
`;
export const StyleKvWrapper = styled.div`
    max-width: 645px;
    width: 100%;
    margin-bottom: -12px;
    /* background-image: url('/assets/img/kvkv.jpg');
    background-repeat: no-repeat;
    background-size: cover; */
    @media ${breakpoint.md} {
        margin: 0;
        margin-right: -24px;
    }
`;
export const StyleContent = styled.div`
    max-width: 645px;
    background-color: ${colorToken.white};
    border-radius: 12px;
    /* padding: 24px 24px; */
    max-height: ${({ openedStep }) => (openedStep ? "auto" : "0")};
    padding: ${({ openedStep }) => (openedStep ? "24px 24px" : "0")};
    width: ${({ openedStep }) => (openedStep ? "100%" : "0")};
    overflow: ${({ openedStep }) => (openedStep ? "default" : "hidden")};
    @media ${breakpoint.md} {
        display: flex;
        /* padding: 24px 48px; */
        border-radius: 24px;
        max-width: unset;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    small {
        font-size: 1.2rem;
        font-weight: bold;
    }

    hr {
        width: 100%;
    }
`;


export const StyleParagraphText = styled.div`
    font-weight: 300;
    font-family: 'VWHeadWeb';
    font-size: 18px;
    color: #4a4a4a;
`;

export const StyleTitleText = styled.h1`
    font-weight: 300;
    font-family: "VWHeadWeb";
    font-size: 30px;
    margin-bottom: 12px;
    strong{
        font-family: 'VWHeadWeb';
        font-weight: bold;
        color: #00aff0;
        display: block;
    }
`;

export const StyleNumeros = styled.div`
    display: flex;
    gap: 0 12px;
    flex-wrap: wrap;
    margin-bottom: 12px;
`;

export const StyleNumeroItem = styled.div`
    color: ${colorToken.color1};
    font-weight: bold;
    font-size: 1.6rem;
    width: 80px;
`;

export const StyleUser = styled.div`
    color: ${colorToken.white};
    text-align: right;
    font-size: 16px;
    padding-right: 24px;
    line-height: 32px;
`;

export const StyleContentNumeros = styled.div`
    width: 100%;
    background-color: ${colorToken.white};
    border-radius: 12px;
    padding: 24px 12px;
    text-align: center;
    img { 
        margin-bottom: 36px;
    }
    @media ${breakpoint.md} {
        padding: 24px 48px;
        /* display: flex;
        border-radius: 24px;
        max-width: unset;
        justify-content: start;
        flex-direction: column;
        align-items: center; */
    }
    small {
        font-size: 1.2rem;
        font-weight: bold;
    }
    > * {
        text-align: left;
    }

    ${StyleTitleText}{
        font-size: 1.6rem;
        @media ${breakpoint.md} {
            font-size: 2.4rem;
        }
    }
`;




//================================================

// export const StyleContent = styled.div`
//     padding: 0 16px 32px;
//     button{
//         margin-top: 12px;
//     }
//     @media ${breakpoint.lg} {
//         flex-basis: 68%;
//     }
// `;


export const StyleWrapperInput = styled.div`

`

export const StyleKeyVisualWrapper = styled.div`
    background-image: url("/assets/img/volksvale_kv.jpg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-color: ${colorToken.color3};
    background-position: top center;
    /* flex-basis: 100%; */
    flex-basis: 280px;
    @media ${breakpoint.md} {
        flex-basis: 40%;
    }
    @media ${breakpoint.lg} {
        flex-basis: 50%;
    }
`;

// export const StyleContentWrapper = styled.div`
//     background-image: url("/assets/img/volksvale_bg.png");
//     background-position: center;
//     background-size: cover;
//     flex-grow: 1;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     @media ${breakpoint.lg} {
//         justify-content: flex-start;
//         padding-left: 6%;
//         padding-top: 80px;
//     }
// `;


export const StyleVolksHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 0 20px;
    padding: 12px 0;
    width: 100%;
    svg {
        width: 39px;
    }
    @media ${breakpoint.lg} {
        padding: 12px 0;
    }
`
export const StyleLineLeft = styled.div`
    height: 2px;
    border-radius: 0 1px 1px 0;
    background-color: ${colorToken.white};
    flex-grow: 1;
    box-shadow: 1px 0 rgba(0,71,118, 0.4);
`
export const StyleLineRight = styled.div`
    height: 2px;
    border-radius: 1px 0 0 1px;
    background-color: ${colorToken.white};
    /* flex-basis: 16%; */
    flex-grow: 1;
`
export const StyleLogo = styled.div`
    flex-basis: 51px;
    @media ${breakpoint.lg} {
        flex-basis: 51px;
    }
`

export const LogoVw = () => (
    <svg id="b" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112.22 112.22">
        <g id="c">
            <path
                d="m56.11,112.22c31.03,0,56.11-25.08,56.11-56.11C112.22,25.08,87.15,0,56.11,0,25.08,0,0,25.08,0,56.11c0,31.03,25.08,56.11,56.11,56.11m-16.22-30.8c-.31,0-.47-.31-.63-.63L13.4,28.68c4.62-7.05,10.81-13.01,18.26-17.16l18.57,41.38c.31.78.78.94,1.41.94h8.93c.63,0,1.1-.16,1.41-.94l18.57-41.38c7.44,4.15,13.64,10.11,18.26,17.16l-25.86,52.11c-.16.31-.31.63-.63.63-.31,0-.47-.31-.63-.63l-9.72-22.26c-.31-.78-.78-.94-1.41-.94h-8.93c-.63,0-1.1.16-1.41.94l-9.72,22.26c-.16.31-.31.63-.63.63m16.22-36.83c-.31,0-.47-.31-.63-.63l-15.99-35.89c5.17-1.88,10.81-2.9,16.61-2.9s11.44,1.02,16.61,2.9l-15.99,35.89c-.16.31-.31.63-.63.63m0,62.46c-27.9,0-50.78-23.04-50.78-50.94,0-6.27,1.1-12.23,3.21-17.79l29.7,59.8c.39.79.86,1.41,1.8,1.41.94,0,1.46-.64,1.8-1.41l13.64-30.64c.16-.31.31-.63.63-.63.31,0,.47.31.63.63l13.64,30.64c.34.77.86,1.41,1.8,1.41.94,0,1.41-.62,1.8-1.41l29.7-59.8c2.12,5.56,3.21,11.52,3.21,17.79,0,27.9-22.88,50.94-50.78,50.94"
                style={{ fill: colorToken.white, strokeWidth: "0px" }}
            />
        </g>
    </svg>
);

export const StyleLuckNumberContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 24px;
    h2 {
        margin-bottom: 0;
        padding-bottom: 0;
        font-size: 1.5rem;
    }

    strong {
        font-size: 4rem;
        line-height: 40px;
        color: ${colorToken.color1};
        display: block;
    }
`
export const StyleDataBestDrive = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: flex-start;
    margin-bottom: 8px;
`

export const StyleDescriptionBestDrive = styled.div`
font-size: 1.2rem;
margin: 0;
line-height: 16px;
`

export const StyleInfoBestDrive = styled.div`
font-size: 1.6rem;
line-height: 18px;
&.highlight {
    color: ${colorToken.color1};
    font-weight: bold;
    font-size: 1.8rem;   
}
`